import React from "react";
import AdminHeader from "../shared/admin/AdminHeader";

const AdminLayout = (props) => {
  return (
    <>
      <AdminHeader />
      <main className="admin_main">{props.children}</main>
    </>
  );
};

export default AdminLayout;
